import { render, staticRenderFns } from "./SimpleFormB.vue?vue&type=template&id=21479738&scoped=true&"
import script from "./SimpleFormB.vue?vue&type=script&lang=ts&"
export * from "./SimpleFormB.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleFormB.vue?vue&type=style&index=0&id=21479738&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21479738",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/3ce44491/1/fsi-lab/soft/app/robot-config/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VAlert,VCheckbox,VContainer,VFlex,VForm,VIcon,VLayout,VTextField,VTooltip})
